import { t } from 'i18next';
import { runSchemaValidator } from 'utils/old-ui-commons/form';
import { isCnpj, isEmail, isFilled } from 'utils/old-ui-commons/validations';

export const phoneValidator = (value) => {
  if (!isFilled(value)) {
    return false;
  }

  const isInvalidPhoneNumber = value.length < 14;
  if (isInvalidPhoneNumber) {
    return false;
  }
  return true;
};

const validatorForm = (values) =>
  runSchemaValidator(
    {
      agreeTerms: [
        {
          message: t`Accept the terms to continue.`,
          validate: (value) => value,
        },
      ],
      cnpj: [
        {
          message: t`Type a valid document number.`,
          validate: isCnpj,
        },
      ],
      email: [
        {
          message: t`Type a valid email.`,
          validate: isEmail,
        },
      ],
      name: [
        {
          message: t`Name is required.`,
          validate: isFilled,
        },
      ],
      mobile_phone: [
        {
          message: t`Insert a valid mobile number`,
          validate: phoneValidator,
        },
      ],
    },
    values
  );

export default validatorForm;
